import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Restaurantregistratie',
  description: 'Stap {{activeStep}} van {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Basisinfo',
    [Step.BusinessDetails]: 'Bedrijfsgegevens',
  },
  form: {
    name: {
      label: 'Restaurantnaam',
      placeholder: 'Voer restaurantnaam in',
    },
    timezone: {
      label: 'Tijdzone',
      placeholder: 'Zoek op stad of tijdzone',
      inference_failed: 'We konden de tijdzone niet bepalen op basis van dit adres — selecteer deze zelf.',
    },
    google_place: {
      label: 'Geselecteerde Google-locatie: {{name}}',
    },
    is_franchise: {
      label: 'Restaurant maakt deel uit van een merk',
    },
    other_platforms: {
      label: 'Huidige bezorgplatforms',
      description: 'Selecteer alle platforms waarop u momenteel staat',
    },
    pos_system: {
      label: 'Huidig kassasysteem',
      placeholder: 'Selecteer uw kassasysteem',
      options: {
        [PosSystems.Other]: 'Anders',
      },
    },
    delivery_mode: {
      label: 'Bezorgmodus',
      placeholder: 'Selecteer bezorgmodus',
      options: {
        [DeliveryMode.Internal]: 'Intern (eigen bezorgers)',
        [DeliveryMode.External]: 'Extern (derde partij)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Maandelijkse bezorgomzet',
      description: 'Totale omzet op alle bezorgplatforms',
      placeholder: 'Selecteer omzetbereik',
      options: {
        other: 'Anders',
      },
      other: {
        placeholder: 'Voer omzetbedrag in',
      },
    },
    lead_source: {
      label: 'Leadbron',
      description: 'Hoe heeft u van ons gehoord?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Acquisitie door Sales Development Representative',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'Via website of marketing bij ons terechtgekomen',
        },
        [LeadSources.Referral]: {
          title: 'Verwijzing - Bestaand restaurant',
          description: 'Doorverwezen door een van onze partnerrestaurants',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Zelf gegenereerd - Koud',
          description: 'Gevonden via cold outreach of prospectie',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Zelf gegenereerd - Verwijzing',
          description: 'Persoonlijk netwerk of relatie',
        },
        [LeadSources.Tipster]: {
          title: 'Tipgever',
          description: 'Foodamigos betaalt persoon/bedrijf X een commissie voor de aanbeveling',
        },
      },
    },
    sdr: {
      description: 'Selecteer de SDR verantwoordelijk voor deze lead',
    },
    has_instagram_profile: {
      label: 'Instagram-profiel',
      description: 'Heeft uw restaurant een Instagram-profiel?',
      options: {
        true: 'Ja',
        false: 'Nee',
      },
    },
  },
  buttons: {
    back: 'Terug',
    next: 'Volgende',
    complete_registration: 'Registratie voltooien',
  },
  basic_information: {
    title: 'Basisinformatie',
    description: 'Voer de basisgegevens en contactinformatie van het restaurant in',
  },
  restaurant_type: {
    title: 'Restauranttype en servicemodel',
    description: 'Kies het formaat dat het beste de servicestijl van dit restaurant beschrijft',
  },
  cuisine_type: {
    title: 'Voedselcategorieën en keukentypes',
    description: 'Selecteer alle voedselcategorieën en keukentypes die van toepassing zijn',
    placeholder: 'Keukentypes zoeken',
  },
  business_details: {
    title: 'Bedrijfsgegevens',
    description: 'Help ons uw huidige activiteiten te begrijpen',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Full-service restaurant',
      description: 'Eten in zaal met tafelservice',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast casual',
      description: 'Bestellen aan balie/app, hogere kwaliteit & aanpassing dan QSR, zitplaatsen optioneel',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Snelle service (QSR) / Afhalen',
      description: 'Snelheid voorop aan de balie; voornamelijk afhalen',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café & Bakkerij',
      description: 'Koffie, gebak, lichte maaltijden, ontbijt/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Dessert & IJs',
      description: 'Op zoetwaren gerichte concepten',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Dranken & Bar',
      description: 'Drankgerichte locaties; eten optioneel; alcoholbezorging conform lokale regels',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Alleen bezorging / Ghost Kitchen',
      description: 'Geen winkel; virtuele merken en cloudkeukens',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgers',
    [CuisineTypes.ChickenFried]: 'Gebakken kip',
    [CuisineTypes.Wings]: 'Wings',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Sandwiches',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Salades',
    [CuisineTypes.Healthy]: 'Gezond',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegan',
    [CuisineTypes.Vegetarian]: 'Vegetarisch',
    [CuisineTypes.GlutenFree]: 'Glutenvrij',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japans',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Koreaans',
    [CuisineTypes.KoreanFriedChicken]: 'Koreaanse gebakken kip',
    [CuisineTypes.Chinese]: 'Chinees',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Kantonees/Dim Sum',
    [CuisineTypes.Thai]: 'Thais',
    [CuisineTypes.Vietnamese]: 'Vietnamees',
    [CuisineTypes.Malaysian]: 'Maleisisch',
    [CuisineTypes.Indonesian]: 'Indonesisch',
    [CuisineTypes.Filipino]: 'Filipijns',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indiaas',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistaans',
    [CuisineTypes.SriLankan]: 'Sri Lankaans',
    [CuisineTypes.Nepalese]: 'Nepalees',

    [CuisineTypes.Turkish]: 'Turks',
    [CuisineTypes.Lebanese]: 'Libanees',
    [CuisineTypes.Syrian]: 'Syrisch',
    [CuisineTypes.Israeli]: 'Israëlisch',
    [CuisineTypes.Egyptian]: 'Egyptisch',
    [CuisineTypes.PersianIranian]: 'Perzisch/Iraans',
    [CuisineTypes.Iraqi]: 'Iraaks',
    [CuisineTypes.Afghan]: 'Afghaans',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Grieks',
    [CuisineTypes.Mediterranean]: 'Mediterraan',

    [CuisineTypes.Italian]: 'Italiaans',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'Frans',
    [CuisineTypes.SpanishTapas]: 'Spaans/Tapas',
    [CuisineTypes.Portuguese]: 'Portugees',
    [CuisineTypes.German]: 'Duits',
    [CuisineTypes.Austrian]: 'Oostenrijks',
    [CuisineTypes.Balkan]: 'Balkan',
    [CuisineTypes.Hungarian]: 'Hongaars',
    [CuisineTypes.Polish]: 'Pools',
    [CuisineTypes.Czech]: 'Tsjechisch',
    [CuisineTypes.Georgian]: 'Georgisch',

    [CuisineTypes.Mexican]: 'Mexicaans',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruaans',
    [CuisineTypes.Brazilian]: 'Braziliaans',
    [CuisineTypes.Argentinian]: 'Argentijns',
    [CuisineTypes.Caribbean]: 'Caribisch',
    [CuisineTypes.BBQAmerican]: 'BBQ/Amerikaans',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'Amerikaans (Algemeen)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Zeevruchten',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Gestoomde Vis',

    [CuisineTypes.BreakfastBrunch]: 'Ontbijt/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Bakkerij',
    [CuisineTypes.PastryDessert]: 'Gebak/Dessert',
    [CuisineTypes.WafflesCrepes]: 'Wafels/Crêpes',
    [CuisineTypes.IceCreamGelato]: 'IJs/Gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Taarten',

    [CuisineTypes.CoffeeCafe]: 'Koffie/Café',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Sap/Smoothies',
    [CuisineTypes.Milkshakes]: 'Milkshakes',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Wijnbar',
    [CuisineTypes.Cocktails]: 'Cocktails',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Kleine Gerechten',
    [CuisineTypes.Noodles]: 'Noedels',
    [CuisineTypes.Soup]: 'Soep',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Streetfood',
    [CuisineTypes.OrganicBio]: 'Biologisch/Bio',
    [CuisineTypes.KidsMenu]: 'Kindermenu',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/Algemeen',
    [CuisineCategories.AsianPacific]: 'Aziatisch/Pacific',
    [CuisineCategories.SouthAsian]: 'Zuid-Aziatisch',
    [CuisineCategories.MiddleEastMediterranean]: 'Midden-Oosten/Mediterraan',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: "Amerika's",
    [CuisineCategories.SeafoodSpecialty]: 'Zeevruchten Specialiteit',
    [CuisineCategories.BreakfastBakerySweets]: 'Ontbijt Bakkerij/Zoetigheden',
    [CuisineCategories.BeverageLed]: 'Dranken',
    [CuisineCategories.OtherConcepts]: 'Overige Concepten',
  },
};
